<template>
  <div class="editor-bar-list flex footer" :class="{'ios-editor-bar': isIos}">
    <div class="bar-container flex-start">
      <div v-for="item in operating" :key="item.type" class="bar-item flex-column-center" @click="toDetail(item)">
        <div class="count flex-center" v-if="count && item.type === 'suggest' && score">{{ count }}</div>
        <img :src="item.icon" alt="" class="image">
        <span class="label">{{ item.label }}</span>
      </div>
    </div>
    <button class="theme-button module-btn flex-center" @click="toModuleManage">模块管理</button>
  </div>
</template>

<script>
	import { envMixin } from '../../assets/js/mixin/global'
	export default {
		name: 'cv-editor-bar',
		mixins: [ envMixin ],
		props: {
			count: {
				type: [ Number, String ],
				default: 0
			},
			score: {
				type: [ Number, String ],
				default: 0
			}
		},
		data () {
			return {}
		},
		mounted () {
			this.iosReview()
		},
		computed: {
			operating () {
				if (this.isReviewOfIos && this.isIos) {
					return [
						// { label: '优化建议', icon: 'https://files.wondercv.com/mobile/cvs/editor-suggest.png', type: 'suggest' },
						{ label: '更多', icon: 'https://files.wondercv.com/mobile/cvs/editor-more.png', type: 'more' }
					]
				} else {
					return [
						// { label: '优化建议', icon: 'https://files.wondercv.com/mobile/cvs/editor-suggest.png', type: 'suggest' },
						{ label: '更多', icon: 'https://files.wondercv.com/mobile/cvs/editor-more.png', type: 'more' },
						{ label: '导师辅导', icon: 'https://files.wondercv.com/mobile/cvs/editor-service.png', type: 'mentor' }
					]
				}
			}
		},
		watch: {},
		components: {},
		methods: {
			toDetail (item) {
				this.$emit('handleClick', item)
			},
			// 跳转至模块管理页面
			toModuleManage () {
				this.routeTo(`/cvs/${ this.$route.params.token }/module`)
			}
		}
	}
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/global/variable';
  @import '@/assets/scss/global/mixin';
  .editor-bar-list {
    width: 100vw;
    background-color: $color-light;
    box-shadow: 0 2px 15px 0 #c5c5c5;
    box-sizing: border-box;
    align-items: center;
    padding: 0 36px;
    @include ipx-footer(50px, 1px);
    z-index: 1;
    .bar-container {
      flex: 1;
      .bar-item {
        position: relative;
        margin-right: 28px;
        .image {
          width: 22px;
          height: 22px;
          object-fit: contain;
          margin-bottom: 4px;
        }
        .label {
          font-size: $font-size-small-s;
          color: #545564;
          font-weight: 500;
          white-space: nowrap;
        }
        .count {
          position: absolute;
          top: 3px;
          margin-left: 16px;
          width: 22px;
          height: 18px;
          background-color: $color-theme;
          color: $color-light;
          border-radius: 10px;
          font-size: $font-size-small;
        }
      }
    }
    .module-btn {
      width: 190px;
      height: 38px;
      border-radius: 4px;
      font-size: $font-size-medium;
    }
  }
  .ios-editor-bar {
    height: 50px !important;
    padding-bottom: 0 !important;
  }
</style>
